// @ts-nocheck
import React, { Suspense } from "react";
import Home from 'pages/Home';
import Novini from 'pages/Novini';
import Bosco from 'pages/Bosco';
import Footer from 'components/footer/Footer';
import { Routes, Route } from "react-router-dom";
import Header from "components/header/Header";
import HeaderHome from "components/header/HeaderHome";
import SaleziyaniOtcyaBosko from "pages/SaleziyaniOtcyaBosko";
import OtecBoskoSogodni from "pages/OtecBoskoSogodni";
import DochkiMariyiPomichniciFma from "pages/DochkiMariyiPomichniciFma";
import SaleziyaniSpivpracivniki from "pages/SaleziyaniSpivpracivniki";
// @ts-ignore
import SaleziyanskiVipuskniki from "pages/SaleziyanskiVipuskniki";
import SocialnePidpriyemnictvo from "pages/SocialnePidpriyemnictvo";
import Komunikaciya from "pages/Komunikaciya";
import PreventivoIt from "pages/PreventivoIt";
import PreventivoUa from "pages/PreventivoUa";
import Harizma from "pages/Harizma";
import SalezianyUKR from "pages/SalezianyUKR";
import Urjad from "pages/Urjad";
import AsociaciyaMariyiPomichnici from "pages/AsociaciyaMariyiPomichnici";
import PiznajSvoyePoklikannya from "pages/PiznajSvoyePoklikannya";
import PostijnaFormaciya from "pages/PostijnaFormaciya";
import Noviciat from "pages/Noviciat";
import Kandidatura from "pages/Kandidatura";
import AspirantatUchitelyuDePerebuvayesh from "pages/AspirantatUchitelyuDePerebuvayesh";
import DushpastirskiMateriali from "pages/DushpastirskiMateriali";
import FormacijniMateriali from "pages/FormacijniMateriali";
import IstoriyaSvIvanaBosko from "pages/IstoriyaSvIvanaBosko";
import BiografiyaSaleziyan from "pages/BiografiyaSaleziyan";
import Necrology from "pages/Necrology";
import SaleziyanskijOfisRozvitku from "pages/SaleziyanskijOfisRozvitku";
import IntrevyuZSaleziyaninom from "pages/IntrevyuZSaleziyaninom";
import Novina from "./pages/Novina";
import VypusknykyPage from "pages/VypusknykyPage";
import MsrPage from "pages/MsrPage";
import StudentyPage from "pages/StudentyPage";
import OsvitaPage from "pages/OsvitaPage";
import RodynnyiPage from "pages/RodynnyiPage";
import SportPage2 from "pages/SportPage2";
import OratoriaPage from "pages/OratoriaPage";
import SportPage from "pages/SportPage";
import ProvinciaPage from "./pages/ProvinciaPage";
import ParafiaPage from "./pages/ParafiaPage";
import VynnykyPage from "./pages/VynnykyPage";
import MariaPage from "./pages/MariaPage";
import MariaKyivPage from "./pages/MariaKyivPage";
import CentreBoscoPage from "./pages/CentreBoscoPage";
import DniproPage from "./pages/DniproPage";
import ShidnyciaPage from "./pages/ShidnyciaPage";
import NovosilkaPage from "./pages/NovosilkaPage";
import KorostivHram from "./pages/KorostivHram";
import Korostiv from "./pages/Korostiv";
import ShkolaPage from "./pages/ShkolaPage";
import Postnoviciat from "./pages/Postnoviciat";
import Practika from "./pages/Practika";
import Bogoslivja from "./pages/Bogoslivja";
import Blog1 from "./pages/Blog1";
import Blog2 from "./pages/Blog2";
import Blog3 from "./pages/Blog3";
import Blog4 from "./pages/Blog4";

const App = () => {
  return (
    <div className="flex flex-col justify-between min-h-screen">
      <Routes>
        <Route path="/">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <HeaderHome isHomePage className="h-[300px] md:h-screen bg-home-page-img" />
                <Home />
              </Suspense>
            }
          />
        </Route>
        <Route path="/zustrich-vertepiv-spilnot-molodizhnoho-saleziianskoho-rukhu">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <Blog1 />
              </Suspense>
            }
          />
        </Route>
        <Route path="/rozzbroity-nashi-sertsia-zarady-myru">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <Blog2 />
              </Suspense>
            }
          />
        </Route>
        <Route path="/poslannia-heneralnoho-nastoiatelia-saleziian-na-sichen-2026">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <Blog3 />
              </Suspense>
            }
          />
        </Route>
        <Route path="/gaslo-2026">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <Blog4 />
              </Suspense>
            }
          />
        </Route>
        <Route path="/oratoria">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <OratoriaPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="/parafia">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <ParafiaPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="/shkola">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <ShkolaPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="/sport">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <SportPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="/vypusknyky">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <VypusknykyPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="/msr">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <MsrPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="/studenty">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <StudentyPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="/rodynnyi">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <RodynnyiPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="/osvita">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <OsvitaPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="/sportpage">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <SportPage2 />
              </Suspense>
            }
          />
        </Route>
        <Route path="/maria">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <MariaPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="/maria-kyiv">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <MariaKyivPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="/vynnyky">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <VynnykyPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="/centre-bosco">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <CentreBoscoPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="/dnipro">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <DniproPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="/korostiv">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <Korostiv />
              </Suspense>
            }
          />
        </Route>
        <Route path="/shidnycia">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <ShidnyciaPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="/novosilka">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <NovosilkaPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="/korostiv-hram">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <KorostivHram />
              </Suspense>
            }
          />
        </Route>
        <Route path="/provincia">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <ProvinciaPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="/svyatij-ivan-bosko">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <Bosco />
              </Suspense>
            }
          />
        </Route>
        <Route path="/saleziyanska-harizma">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <Harizma />
              </Suspense>
            }
          />
        </Route>
        <Route path="/saleziyani-v-ukrayini">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <SalezianyUKR />
              </Suspense>
            }
          />
        </Route>
        <Route path="/vikonavchij-uryad-provinciyi">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <Urjad />
              </Suspense>
            }
          />
        </Route>
        <Route path="/saleziyani-otcya-bosko">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <SaleziyaniOtcyaBosko />
              </Suspense>
            }
          />
        </Route>
        <Route path="/otec-bosko-sogodni">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <OtecBoskoSogodni />
              </Suspense>
            }
          />
        </Route>
        <Route path="/dochki-mariyi-pomichnici-fma">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <DochkiMariyiPomichniciFma />
              </Suspense>
            }
          />
        </Route>
        <Route path="/saleziyani-spivpracivniki">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <SaleziyaniSpivpracivniki />
              </Suspense>
            }
          />
        </Route>
        <Route path="/saleziyanski-vipuskniki">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <SaleziyanskiVipuskniki />
              </Suspense>
            }
          />
        </Route>
        <Route path="/asociaciya-mariyi-pomichnici">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <AsociaciyaMariyiPomichnici />
              </Suspense>
            }
          />
        </Route>
        <Route path="/piznaj-svoye-poklikannya">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <PiznajSvoyePoklikannya />
              </Suspense>
            }
          />
        </Route>
        <Route path="/aspirantat-uchitelyu-de-perebuvayesh">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <AspirantatUchitelyuDePerebuvayesh />
              </Suspense>
            }
          />
        </Route>
        <Route path="/kandidatura">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <Kandidatura />
              </Suspense>
            }
          />
        </Route>
        <Route path="/noviciat">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <Noviciat />
              </Suspense>
            }
          />
        </Route>
        <Route path="/postnoviciat">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <Postnoviciat />
              </Suspense>
            }
          />
        </Route>
        <Route path="/practika">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <Practika />
              </Suspense>
            }
          />
        </Route>
        <Route path="/bogoslivja">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <Bogoslivja />
              </Suspense>
            }
          />
        </Route>
        <Route path="/postijna-formaciya">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <PostijnaFormaciya />
              </Suspense>
            }
          />
        </Route>
        <Route path="/dushpastirski-materiali">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <DushpastirskiMateriali />
              </Suspense>
            }
          />
        </Route>
        <Route path="/komunikaciya">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <Komunikaciya />
              </Suspense>
            }
          />
        </Route>
        <Route path="/socialne-pidpriyemnictvo">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <SocialnePidpriyemnictvo />
              </Suspense>
            }
          />
        </Route>
        <Route path="/novini">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <Novini />
              </Suspense>
            }
          />
        </Route>
        <Route path="/novina">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <Novina />
              </Suspense>
            }
          />
        </Route>
        <Route path="/formacijni-materiali">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <FormacijniMateriali />
              </Suspense>
            }
          />
        </Route>
        <Route path="/istoriya-sv-ivana-bosko">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <IstoriyaSvIvanaBosko />
              </Suspense>
            }
          />
        </Route>
        <Route path="/saleziyanskij-ofis-rozvitku">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <SaleziyanskijOfisRozvitku />
              </Suspense>
            }
          />
        </Route>
        <Route path="/intrevyu-z-saleziyaninom">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <IntrevyuZSaleziyaninom />
              </Suspense>
            }
          />
        </Route>
        <Route path="/nekrology">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <Necrology />
              </Suspense>
            }
          />
        </Route>
        <Route path="/biografiya-saleziyan">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <BiografiyaSaleziyan />
              </Suspense>
            }
          />
        </Route>
        <Route path="/preventivo-it">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <PreventivoIt />
              </Suspense>
            }
          />
        </Route>
        <Route path="/preventivo-ua">
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Header />
                <PreventivoUa />
              </Suspense>
            }
          />
        </Route>
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
